/* @flow */
/*jshint esversion: 6 */
import React, { Component } from "react";
import "../../App.css";
import GenericTable from "../../components/GenericTable";
import LangContext from "../../contextProvider/LangContext";
import PageToolbar from "../../components/PageToolbar";
import { Form, Button } from "antd";
import GenericSelector from "../../components/GenericSelector";
import GenericSelectorPosStorages from "../../components/GenericSelectorPosStorages";
import PictureView from "../../components/PictureView";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import GenericModal from "../../components/GenericModal";
import TableLineIcons from "../../components/TableLineIcons";


class PosImages extends Component {
    constructor(props: Props) {
        super(props);
        this.state = {
            _imageType: null,
            _posList: '',
            _fileName: null,
            modalTable: false
        };

        if (props.data.IMAGE_TYPES_LIST === undefined) props.data.IMAGE_TYPES_LIST = { ...props.data.genericSelector };
        if (props.data.IMAGE_POS_LIST === undefined) props.data.IMAGE_POS_LIST = { ...props.data.genericData };

    }

    static contextType = LangContext;

    getText = (id) => {
        return this.context.get(id) || '[' + id + ']'
    }

    componentDidUpdate() {
        document.title = "Cash On Tab - " + this.getText(21801);
    }

    onRemove = (_id, _fileName, next) => {
        this.sendAPI("delete_pos_images", { _fileName, _id }, next)
    }

    onChange = (v) => {
        const { _posList } = this.state
        this.sendAPI("save_pos_images", { _posList, _fileName: v }, () => {
            this.setState({ _fileName: v })
        })
    }

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    renderFileType = (t) => {
        switch (t) {
            case "G": return this.getText(22763);
            case "H": return this.getText(22764);
            case "U": return this.getText(22765);
            default: return t;
        }
    }

    imgUrl = (x) => {
        let origin = window.location.origin;
        let baseUrl = origin == 'http://localhost:3000' ? "https://devcashontab.co.il" : origin;
        return baseUrl + "/uploads/" + this.props.user.companyCode + "/" + x;
    }

    renderEdit = (text, record) => {
        return (<TableLineIcons
            genericIcons={[
                {
                    type: "file-image",
                    onClick: () => {
                        this.setState({ modalImage: record.iFileName })
                    },
                    tooltip: this.getText(22766),
                }, {
                    type: "delete",
                    onClick: () => {
                        this.onRemove(record.iId, record.iFileName, () => { 
                            this.props.dataActions.genericDataGetRequested(
                                "IMAGE_POS_LIST", this.props.user.companyCode, this.props.user.token, "get_image_pos_list");
                        })
                    },
                    tooltip: this.getText(22767),
                    popconfirm: { title: this.getText(22768), okText: this.getText(22769), cancelText: this.getText(22770) },
                }
            ]}
        />)
    }

    render() {
        let gt = this.getText;

        const divStyle = {
            align: "center",
            dir: "rtl",
            padding: "2% 2% 2% 2%",
            width: window.innerWidth <= 600 ? "100%" : 600,
            margin: "auto",
        };

        const sorter = true

        const render = t => t

        return (<div style={divStyle}>
            <PageToolbar title={gt(21801)} actionButtons={[]} />
            <Form.Item label={gt(21802)}>
                <GenericSelector
                    {...this.props}
                    value={this.state._imageType}
                    onChange={e => { this.setState({ _imageType: e }) }}
                    dataset={["G", "H", "U"].map(x => { return { code: x, name: this.renderFileType(x) } })}
                />
            </Form.Item>
            <Form.Item label={gt(21803)}>
                <GenericSelectorPosStorages
                    {...this.props}
                    multi
                    value={this.state._posList ? this.state._posList.split(",") : []}
                    onChange={e => { this.setState({ _posList: e ? e.join(",") : "" }) }}
                />
            </Form.Item>
            <Form.Item label={gt(21804)}>
                <PictureView
                    {...this.props}
                    imageType={this.state._imageType}
                    url={this.state._fileName}
                    onRemove={() => { this.onRemove(null, this.state._fileName, () => { this.setState({ _fileName: null }) }) }}
                    onChange={this.onChange}
                    disabled={!this.state._imageType || !this.state._posList}
                    onUploadedSuccess={() => { }} onUploadedFailed={() => { }}
                />
            </Form.Item>
            <Button type="primary" onClick={() => { this.setState({ modalTable: true }) }}>{gt(22755)}</Button>
            <GenericModal
                visible={this.state.modalTable}
                onCancel={() => { this.setState({ modalTable: false }) }}
                title={gt(22755)}>
                {this.state.modalTable && (
                    <GenericTable
                        {...this.props}
                        tableOnly
                        id={"IMAGE_POS_LIST"}
                        getApi={"get_image_pos_list"}
                        columns={[
                            { title: gt(22756), dataIndex: 'iBranchID', key: 'iBranchID', width: "10%", sorter, render },
                            { title: gt(22757), dataIndex: 'iBranchName', key: 'iBranchName', width: "18%", sorter, render },
                            { title: gt(22758), dataIndex: 'iPOSID', key: 'iPOSID', width: "10%", sorter, render },
                            { title: gt(22759), dataIndex: 'iPOSName', key: 'iPOSName', width: "18%", sorter, render },
                            { title: gt(22760), dataIndex: 'iFileType', key: 'iFileType', width: "14%", sorter, render: this.renderFileType },
                            { title: gt(22761), dataIndex: 'iFileName', key: 'iFileName', width: "20%", sorter, render },
                            { title: gt(22762), dataIndex: 'iId', key: 'iId', width: "10%", render: this.renderEdit },
                        ]}
                    />)}
                <GenericModal
                    visible={this.state.modalImage}
                    onCancel={() => { this.setState({ modalImage: null }) }}
                    width={400}>
                    {this.state.modalImage && (<img src={this.imgUrl(this.state.modalImage)} style={{ width: "100%" }} />)}
                </GenericModal>
            </GenericModal>
        </div >)
    }

}

export default PosImages;